import * as React from "react";
import Box from "@mui/material/Box";
import { DefaultButton } from "@fluentui/react/lib/Button";
import { LTLState } from "@taskpane/hooks/useLTLReducer";
import { LtlFreightItemCard } from "./LtlFreightItemCard";
import { itemsEditorStyles as styles } from "./itemsEditor.styles";

interface ItemsEditorProps {
  state: LTLState;
  showAddItemInTruckloadMode: boolean;
  showNmfc?: boolean;
  nmfcRequired?: boolean;
  onItemFieldChange: (
    index: number,
    field: keyof LTLState["items"][number],
    value: unknown
  ) => void;
  onFieldBlur?: () => void;
  onAddItem: () => void;
  onRemoveItem: (index: number) => void;
  getTextFieldStyles: (fieldKey: string) => unknown;
  maxWeight?: number;
}

export function ItemsEditor({
  state,
  showAddItemInTruckloadMode,
  showNmfc = true,
  nmfcRequired = false,
  onItemFieldChange,
  onFieldBlur,
  onAddItem,
  onRemoveItem,
  getTextFieldStyles,
  maxWeight,
}: ItemsEditorProps) {
  return (
    <Box sx={styles.section}>
      {state.items.map((item, index) => (
        <LtlFreightItemCard
          key={index}
          item={item}
          index={index}
          totalItems={state.items.length}
          state={state}
          showNmfc={showNmfc}
          nmfcRequired={nmfcRequired}
          onItemFieldChange={onItemFieldChange}
          onFieldBlur={onFieldBlur}
          onRemoveItem={onRemoveItem}
          getTextFieldStyles={getTextFieldStyles}
          maxWeight={maxWeight}
        />
      ))}

      {(showAddItemInTruckloadMode || state.shipmentMode === "LTL") && (
        <DefaultButton
          text="+ Add another item"
          onClick={onAddItem}
          allowDisabledFocus
          styles={styles.addButton}
        />
      )}
    </Box>
  );
}
